<template>
  <div class="login-page-container">
    <div class="bg">
      <div class="auth-box-w">
        <div class="logo-w">
          <img alt :src="require('../../assets/' + app.logo_main)" />
          <h2 class="text-primary">{{ app.name }}</h2>
        </div>
        <h4 class="auth-header">手机验证</h4>
        <div class="text-info-12" style="padding: 0 80px">
          验证手机后，在企业微信内将自动登录。
        </div>
        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <label for>手机号</label>
            <input
              class="form-control"
              v-model="mobile"
              maxlength="11"
              placeholder="输入您的手机号码"
            />
            <div class="pre-icon os-icon os-icon-user-male-circle"></div>
          </div>
          <div v-if="loginType === 'code'" class="form-group">
            <label for>短信验证码</label>
            <div class="flex-row-between">
              <input
                style="flex: 1"
                v-model="code"
                class="form-control"
                placeholder="请输入短信验证码"
                type="text"
              />
              <el-button
                :disabled="inMsgCD"
                class="ml-10"
                style="width: 102px"
                size="medium"
                type="text"
                @click="sendMsg"
              >
                {{ inMsgCD ? msgCoundDown + ' 秒后可重发' : '获取短信验证码' }}
              </el-button>
            </div>

            <div class="pre-icon os-icon os-icon-mail"></div>
          </div>
          <div v-else class="form-group">
            <label for>密码</label>
            <input
              v-model="password"
              class="form-control"
              placeholder="请输入密码"
              type="password"
              autocomplete="current-password"
              required
            />
            <div class="pre-icon os-icon os-icon-fingerprint"></div>
          </div>
          <div class="verification-hint text-info-12">
            <template v-if="loginType === 'code'">
              收不到短信？点击使用<button
                type="button"
                class="verification-switch"
                :disabled="submiting"
                @click="loginType = 'password'"
              >
                密码验证
              </button>
            </template>
            <button
              v-else
              type="button"
              class="verification-switch"
              :disabled="submiting"
              @click="loginType = 'code'"
            >
              使用短信验证
            </button>
          </div>
          <div class="buttons-w">
            <button :disabled="submiting" class="btn btn-primary">确 定</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../store/store'
import { app } from '@/config/env'

import {
  mobileCode,
  mobileLoginPost,
  passwdLoginPost,
} from '../../service/getData'

export default {
  data() {
    return {
      app,
      wxcode: this.$route.query.wxcode,
      mobile: '',
      loginType: 'code',
      password: '',
      submiting: false,
      code: null,
      inMsgCD: false,
      msgButtonTitle: '获取短信验证码',
      msgTimer: null,
      msgCoundDown: 60,
    }
  },
  created() {},
  methods: {
    async handleLogin() {
      if (this.submiting) return
      this.submiting = true
      try {
        let res =
          this.loginType === 'password'
            ? await passwdLoginPost(
                this.mobile,
                this.password,
                undefined,
                undefined,
                this.wxcode,
              )
            : await mobileLoginPost(
                this.mobile,
                parseInt(this.code),
                this.wxcode,
              )
        if (res && res.code == 0) {
          this.loginHandle(res)
        }
      } finally {
        this.submiting = false
      }
    },
    loginHandle(res) {
      res.data.loadRoute = false
      store.commit('login', res.data)
      if (res.data.default_pswd) {
        this.$router.push('/setpswd')
      } else {
        if (store.state.loginRedirect) {
          this.$router.push(store.state.loginRedirect)
        } else {
          this.$router.push('/dashboard')
        }
      }
    },
    async sendMsg() {
      if (this.mobile.length != 11) {
        this.$message.error('请填入正确的手机号')
        return
      }
      let res = await mobileCode(this.mobile)
      if (res.code == 0) {
        this.$message.success('短信已发送')
        this.inMsgCD = true
        this.msgTimer = setInterval(this.runMsgCoundDown, 1000)
      }
    },
    runMsgCoundDown() {
      this.msgCoundDown--
      if (this.msgCoundDown < 0) {
        this.inMsgCD = false
        this.msgCoundDown = 60
        clearInterval(this.msgTimer)
      }
    },
  },
  beforeDestroy() {
    if (this.msgTimer) {
      clearInterval(this.msgTimer)
    }
  },
}
</script>

<style scoped>
.login-page-container {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}

.login-page-container .bg {
  margin-top: 40px;
}

.login-page-container:before {
  content: '';
  position: absolute;
  z-index: -1;
  background-color: #f2f4f7;
  /* background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    from(#ffffff),
    to(#3082f8)
  );
  background: linear-gradient(to bottom right, #ffffff, #3082f8); */
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
}

.logo-w h2 {
  letter-spacing: 2px;
  font-weight: bold;
}

.logo-w img {
  width: 76px;
}

label {
  margin-bottom: 4px;
}

.verification-hint {
  margin-bottom: 16px;
}

.verification-switch {
  padding: 0;
  border: 0;
  background: transparent;
  color: #409eff;
  font: inherit;
  cursor: pointer;
}

.verification-switch:disabled {
  cursor: default;
  opacity: 0.6;
}
</style>
